import { Form, Input, Select } from 'antd';
import type { AllySummary } from '@goelectric/shared-types';
import { allyDisplayName } from '@/features/aliados/utils/format';

interface LocationIdentityFieldsProps {
  /** Aliados del selector. El host los trae con `useAllies` para que el resumen los reuse. */
  allies: AllySummary[];
  alliesLoading?: boolean;
}

/**
 * Paso 1 del alta de Locación: nombre y aliado. "Quién es el dueño" no es "dónde está":
 * el aliado vive acá, no en geolocalización. Se mantiene como bloque propio para espejar el
 * patrón de grupos por paso y reusarlo tal cual desde el modal de edición.
 */
export function LocationIdentityFields({ allies, alliesLoading }: LocationIdentityFieldsProps) {
  const allyOptions = [
    { value: '', label: 'Sin aliado' },
    ...allies.map((ally) => ({ value: ally.id, label: allyDisplayName(ally) })),
  ];

  return (
    <>
      <Form.Item
        label="Nombre"
        name="name"
        rules={[{ required: true, whitespace: true, message: 'Ingresa el nombre de la ubicación.' }]}
      >
        <Input autoComplete="off" placeholder="Introduzca el nombre de la ubicación" />
      </Form.Item>

      {/*
        En el alta, vacío = sin aliado (caso mayoritario: pool que después se ofrece a los
        aliados). En la edición, limpiar el select ("Sin aliado") viaja como `allyId: null`
        y el backend devuelve la Location al tenant de plataforma (ver `buildUpdateBody`).
      */}
      <Form.Item label="Aliado" name="allyId">
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          loading={alliesLoading}
          placeholder="Selecciona el aliado"
          options={allyOptions}
        />
      </Form.Item>
    </>
  );
}
